import {
  Alert,
  Box,
  Card,
  Container,
  Grid,
  Skeleton,
  Snackbar,
  Tab,
  Typography
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { makeStyles } from '@mui/styles';
import {
  TabContext,
  TabList,
  TabPanel,
  Timeline,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineItem,
  TimelineSeparator,
  timelineItemClasses
} from '@mui/lab';
import CircleIcon from '@mui/icons-material/Circle';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import BatteryChargingFullOutlinedIcon from '@mui/icons-material/BatteryChargingFullOutlined';
import moment from 'moment';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import DeviceRfidModal from '../components/_dashboard/smartlock/DeviceRfidModal';
import Header from '../components/navbar/Header';
import DeviceReportExportModal from '../components/_dashboard/smartlock/DeviceReportExportModal';
import Page from '../components/Page';
import CollapsibleTable from '../components/CollapsibleTable';
import {
  GetDeviceDetailById,
  GetDeviceEventData,
  GetOdometerReading,
  GetTripDataByDeviceId
} from '../network/Devices';
import {
  getBatteryIcon,
  getColorAccordingBattery,
  getLocationFromLatLng,
  getStatusColor
} from '../utils/Parser';
import { fNumber } from '../utils/formatNumber';
import { ReactComponent as ExportIcon } from '../icons/exportIcon.svg';
import { getLlockOpenedByChannelIcon, getNotificationEventStatus } from '../utils/Utilities';
import Pagination from '../components/Pagination';
import useFeatures from '../components/customContextProviders/FeatureContext';
import DeviceSettingsModal from '../components/_dashboard/smartlock/DeviceSettingsModal';
import DeviceMapModal from '../components/_dashboard/smartlock/DeviceMapModal';
import NoDataAvailable from '../components/_dashboard/smartlock/NoDataAvailable';

const useStyles = makeStyles({
  labelTypography: {
    color: '#6F6F6F',
    fontWeight: 600,
    fontStyle: 'normal',
    fontSize: '14px',
    lineHeight: '25px'
  },
  valueTypography: {
    color: '#171D40',
    fontWeight: 600,
    fontStyle: 'normal',
    fontSize: '14px',
    lineHeight: '25px',
    textTransform: 'capitalize'
  },
  locationHistoryTitle: {
    fontSize: 14,
    fontWeight: 'bold'
  },

  locationHistoryAddress: {
    fontSize: 12
  },
  boxStyle: {
    display: 'flex',
    flexDirection: 'column',
    gap: 15
  },
  label: {
    fontSize: 14,
    fontWeight: 600,
    lineHeight: '20px',
    textAlign: 'left'
  },
  dateInputField: {
    '& input': {
      padding: '6px 5px',
      borderRadius: 12
    },
    '& .MuiInputBase-input': {
      fontSize: '14px',
      fontWeight: 600
    }
  },
  notFoundContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center'
  },
  actionBg: {
    display: 'flex',
    gap: '5px',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#E7EAEE',
    borderRadius: '10px',
    height: '24px',
    width: 'max-content',
    padding: '0px 8px 0px 8px',
    cursor: 'pointer'
  },
  actionLabel: {
    color: '#171D40',
    fontSize: '13px',
    fontWeight: 700,
    lineHeight: '14px'
  }
});

const validEventTypes = [
  'LOCK_OPENED',
  'REBOOT_DONE',
  'SWITCH_ON',
  'SWITCH_OFF',
  'DEVICE_SLEEP',
  'FLASH_CLEARED'
];

export default function DeviceReport() {
  const classes = useStyles();
  const location = useLocation();
  const feature = useFeatures();

  const { deviceId } = location?.state || '';

  const [open, setOpen] = useState(false);
  const [selectedTab, setSelectedTab] = useState('location');
  const [deviceDetail, setDeviceDetail] = useState({});
  const [city, setCity] = useState('');
  const [deviceTripList, setDeviceTripList] = useState([]);
  const [tripLoader, setTripLoader] = useState(false);
  const [tripPageNumber, setTripPageNumber] = useState(0);
  const [tripDataPerPage, setTripDataPerPage] = useState(10);
  const [isOpenExportModal, setIsOpenExportModal] = useState(false);
  const [deviceActionModal, setDeviceActionModal] = useState(false);
  const [deviceSettingModal, setDeviceSettingModal] = useState(false);
  const [deviceMapModal, setDeviceMapModal] = useState(false);
  const [rfidDataModal, setRfidDataModal] = useState(false);
  const [selectedRfidData, setSelectedRfidData] = useState(null);
  const [odoMeterData, setOdoMeterData] = useState(null);
  const [meterLoader, setMeterLoader] = useState(false);
  const [pageNumber, setPageNumber] = useState(0);
  const [dataPerPage, setDataPerPage] = useState(10);
  const [deviceEventData, setDeviceEventData] = useState([]);
  const [eventLoader, setEventLoader] = useState(false);

  const [alertMetas, setAlertMetas] = useState({
    snackBarOpened: false,
    vertical: 'top',
    horizontal: 'right',
    msg: '',
    variant: 'filled',
    severity: ''
  });

  const vertical = 'bottom';
  const horizontal = 'left';

  // const handleSnackBarClose = (event, reason) => {
  //   if (reason === 'clickaway') {
  //     return;
  //   }
  //   setAlertMetas({ ...alertMetas, snackBarOpened: false });
  // };

  const now = dayjs().startOf('day');
  const todayStart = dayjs();

  const [startDate, setStartDate] = useState(now);
  const [endDate, setEndDate] = useState(todayStart);

  const handlePageNumber = (event, newPage) => {
    setPageNumber(newPage);
  };

  const handleDataPerPage = (event) => {
    setDataPerPage(parseInt(event.target.value, 10));
    setPageNumber(0);
  };
  const handleTripPage = (event, newPage) => {
    setTripPageNumber(newPage);
  };

  const handleTripDataPerPage = (event) => {
    setTripDataPerPage(parseInt(event.target.value, 10));
    setTripPageNumber(0);
  };

  useEffect(() => {
    // If endDate is less than startDate, update endDate to startDate's end of day in epoch milliseconds
    if (endDate < startDate) {
      setStartDate(moment(startDate).endOf('day').valueOf());
    }
    setPageNumber(0);
    setTripPageNumber(0);
  }, [startDate, endDate]);

  const handleStartDateChange = (newValue) => {
    const newStartDate = dayjs(newValue).startOf('day');
    setStartDate(newStartDate);

    if (newStartDate.isAfter(endDate)) {
      setEndDate(newStartDate.endOf('day'));
    }
  };

  const handleEndDateChange = (newValue) => {
    const newEndDate = dayjs(newValue).endOf('day');
    setEndDate(newEndDate);

    if (newEndDate.isBefore(startDate)) {
      setStartDate(newEndDate.startOf('day'));
    }
  };

  const handleDeviceAction = (action) => {
    switch (action) {
      case 'device_setting':
        setDeviceSettingModal(true);
        break;
      case 'device_map':
        setDeviceMapModal(true);
        break;
      default:
        break;
    }
  };

  const handleUnlockChannelModal = (action, event) => {
    if (action === 'LOCK_OPENED' && event.channel !== 'SMS') {
      setRfidDataModal(true);
      setSelectedRfidData(event);
    }
  };

  const getDeviceEventData = async (deviceId, startDate, endDate, page, limit, selectedTab) => {
    setEventLoader(true);
    const startDateEpoch = startDate.valueOf();
    const endDateEpoch = endDate.valueOf();
    try {
      const res = await GetDeviceEventData(
        deviceId,
        startDateEpoch,
        endDateEpoch,
        page + 1,
        limit,
        selectedTab
      );
      setEventLoader(false);
      setDeviceEventData(res?.data?.data);
    } catch (err) {
      setEventLoader(false);
      console.log(err, 'err');
    }
  };

  const getTripData = async (id, tripPageNumber, tripDataPerPage) => {
    setTripLoader(true);
    try {
      const res = await GetTripDataByDeviceId(id, tripPageNumber + 1, tripDataPerPage);
      if (res) {
        setTripLoader(false);
        setDeviceTripList(res?.data);
      }
    } catch (error) {
      setTripLoader(false);
      console.log(error, 'err');
    }
  };

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
    setPageNumber(0);
    setDataPerPage(10);
  };

  const getDeviceData = async (deviceId) => {
    try {
      const res = await GetDeviceDetailById(deviceId);
      if (res) {
        const deviceData = res?.data?.data;
        setDeviceDetail(deviceData);
        if (deviceData?.latestEvent?.location_lat && deviceData?.latestEvent?.location_lng) {
          const cityName = await getLocationFromLatLng(
            deviceData?.latestEvent?.location_lat,
            deviceData?.latestEvent?.location_lng
          );
          setCity(cityName);
        }
      }
    } catch (error) {
      console.log(error, 'err');
    }
  };

  const getDeviceOdometer = async (deviceId, startDate, endDate) => {
    setMeterLoader(true);
    const startDateEpoch = startDate.valueOf();
    const endDateEpoch = endDate.valueOf();
    try {
      const res = await GetOdometerReading(deviceId, startDateEpoch, endDateEpoch);
      setMeterLoader(false);
      setOdoMeterData(res?.data?.data);
    } catch (err) {
      setMeterLoader(false);
      console.log(err, 'err');
    }
  };

  useEffect(() => {
    getDeviceEventData(deviceId, startDate, endDate, pageNumber, dataPerPage, selectedTab);
  }, [selectedTab, deviceId, startDate, endDate, pageNumber, dataPerPage]);

  useEffect(() => {
    getDeviceData(deviceId);
    getDeviceOdometer(deviceId, startDate, endDate);
  }, [deviceId, startDate, endDate]);

  useEffect(() => {
    getTripData(deviceId, tripPageNumber, tripDataPerPage);
  }, [tripPageNumber, tripDataPerPage]);

  return (
    <Page title="Device Report">
      <Snackbar
        anchorOrigin={{ vertical, horizontal }}
        open={alertMetas?.snackBarOpened}
        // onClose={handleSnackBarClose}
        autoHideDuration={6000}
      >
        <Alert variant={alertMetas?.variant} severity={alertMetas?.severity}>
          {alertMetas?.msg}
        </Alert>
      </Snackbar>
      <Header
        onOpenSidebar={() => setOpen(true)}
        // handleSearch={handleTripSearch}
        // handleSubmit={searchTrip}
        name="Device Report"
        showSearch={false}
      />
      <Container maxWidth="false" disableGutters sx={{ padding: 0 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Box
            data-testid="device-name-container"
            sx={{
              display: 'flex',
              flexWrap: 'wrap',
              justifyContent: 'start',
              alignItems: 'center',
              gap: { xs: 2, sm: 40, md: 16 }
            }}
          >
            <Typography sx={{ fontSize: { xs: 14, md: 18 }, fontWeight: 900, fontStyle: 'bold' }}>
              {`${deviceDetail?.name}`}
              {/* {`${deviceDetail?.name} (${deviceDetail?.lock_id})`} */}
            </Typography>
            <Typography
              sx={{
                fontSize: { xs: 12, md: 14 },
                textWrap: 'wrap',
                fontWeight: 400,
                lineHeight: '16px'
              }}
            >
              Last Updated{' '}
              {deviceDetail?.latestEvent?.createdAt
                ? moment(deviceDetail?.latestEvent?.createdAt)
                    .add(5, 'hours')
                    .add(30, 'minutes')
                    .format('DD-MM-YYYY hh:mm:ss A')
                : '--'}
            </Typography>
          </Box>

          <Box
            data-testid="filter-date-container-large-screen"
            sx={{
              display: { xs: 'none', md: 'flex' },
              justifyContent: 'space-between',
              alignItems: 'center',
              gap: '5px',
              marginTop: '5px'
            }}
          >
            <Typography sx={{ fontSize: '14px', fontWeight: 'bold' }}>Filter By Date</Typography>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                slotProps={{
                  textField: {
                    inputProps: { 'data-testid': 'start-date-input-large' },
                    sx: {
                      '& .MuiInputBase-input': {
                        fontSize: '12px',
                        fontWeight: '600',
                        width: '70px',
                        padding: '10px'
                      }
                    }
                  }
                }}
                label="Start Date"
                value={startDate}
                onChange={handleStartDateChange}
                format="DD/MM/YYYY"
              />
              <DatePicker
                slotProps={{
                  textField: {
                    inputProps: { 'data-testid': 'end-date-input-large' },
                    sx: {
                      '& .MuiInputBase-input': {
                        fontSize: '12px',
                        fontWeight: '600',
                        width: '70px',
                        padding: '10px'
                      }
                    }
                  }
                }}
                label="End Date"
                value={endDate}
                onChange={handleEndDateChange}
                format="DD/MM/YYYY"
              />
            </LocalizationProvider>
            {feature?.device?.exportDeviceData && (
              <Box data-testid="export-icon" onClick={() => setIsOpenExportModal(true)}>
                {ExportIcon ? (
                  <ExportIcon
                    style={{ marginLeft: '10px', cursor: 'pointer' }}
                    // onClick={() => setIsOpenExportModal(true)}
                  />
                ) : null}
              </Box>
            )}
          </Box>
        </Box>

        <Grid container spacing={2} mt={1}>
          <Grid item xs={12} md={7}>
            <Card sx={{ width: '100%' }}>
              <Box>
                <Grid data-testid="device-detail-grid" container spacing={1} sx={{ p: 3 }}>
                  <Grid item xs={6} md={3}>
                    <Typography className={classes.labelTypography}>Device Name</Typography>
                  </Grid>
                  <Grid item xs={6} md={3}>
                    <Typography className={classes.valueTypography}>
                      {deviceDetail?.name}
                    </Typography>
                  </Grid>
                  <Grid item xs={6} md={3}>
                    <Typography className={classes.labelTypography}>Location</Typography>
                  </Grid>
                  <Grid item xs={6} md={3}>
                    <Typography className={classes.valueTypography}>{city || '--'}</Typography>
                  </Grid>

                  <Grid item xs={6} md={3}>
                    <Typography className={classes.labelTypography}>FW Version</Typography>
                  </Grid>
                  <Grid item xs={6} md={3}>
                    <Typography className={classes.valueTypography}>
                      {deviceDetail?.latestEvent?.version
                        ? deviceDetail?.latestEvent?.version
                        : '--'}
                    </Typography>
                  </Grid>
                  <Grid item xs={6} md={3}>
                    <Typography className={classes.labelTypography}>Connection</Typography>
                  </Grid>
                  <Grid item xs={6} md={3}>
                    <Typography className={classes.valueTypography}>
                      <CircleIcon
                        sx={{
                          width: '10px',
                          height: '10px',
                          color: getStatusColor(deviceDetail?.deviceLiveStatus)
                        }}
                      />{' '}
                      {deviceDetail?.deviceLiveStatus}
                    </Typography>
                  </Grid>
                  <Grid item xs={6} md={3}>
                    <Typography className={classes.labelTypography}>Status</Typography>
                  </Grid>
                  <Grid item xs={6} md={3}>
                    <Typography className={classes.valueTypography}>
                      {deviceDetail?.device_status}
                    </Typography>
                  </Grid>
                  <Grid item xs={6} md={3}>
                    <Typography className={classes.labelTypography}>Battery</Typography>
                  </Grid>
                  <Grid item xs={6} md={3}>
                    <Typography
                      className={classes.valueTypography}
                      sx={{ display: 'flex', alignItems: 'center' }}
                    >
                      {deviceDetail?.latestEvent?.battery_charging ? (
                        <BatteryChargingFullOutlinedIcon
                          fontSize="small"
                          sx={{
                            color: getColorAccordingBattery(
                              deviceDetail?.latestEvent?.battery_remaining
                            )
                          }}
                        />
                      ) : (
                        getBatteryIcon(
                          deviceDetail?.latestEvent?.battery_remaining,
                          getColorAccordingBattery(deviceDetail?.latestEvent?.battery_remaining)
                        )
                      )}
                      {fNumber(deviceDetail?.latestEvent?.battery_remaining)} %
                    </Typography>
                  </Grid>
                  <Grid item xs={6} md={3}>
                    <Typography className={classes.labelTypography}>Odometer</Typography>
                  </Grid>
                  <Grid item xs={6} md={3}>
                    <Typography className={classes.valueTypography}>
                      {meterLoader ? '--' : `${(odoMeterData?.totalDistance || 0).toFixed(2)} Km`}
                    </Typography>
                  </Grid>

                  {feature?.device?.deviceSetting && (
                    <Grid item xs={6} md={3}>
                      {deviceDetail && Object.keys(deviceDetail).length > 0 && (
                        <Box
                          className={classes.actionBg}
                          onClick={() => handleDeviceAction('device_setting')}
                        >
                          <SettingsOutlinedIcon fontSize="small" />
                          <Typography className={classes.actionLabel}>Setting</Typography>
                        </Box>
                      )}
                    </Grid>
                  )}
                  <Grid item xs={6} md={3}>
                    {deviceDetail && Object.keys(deviceDetail).length > 0 && (
                      <Box
                        className={classes.actionBg}
                        onClick={() => handleDeviceAction('device_map')}
                      >
                        <LocationOnOutlinedIcon fontSize="small" />
                        <Typography className={classes.actionLabel}>Map</Typography>
                      </Box>
                    )}
                  </Grid>
                </Grid>
              </Box>
            </Card>
            <Card
              data-testid="collapsible-table-card"
              sx={{
                display: { xs: 'none', md: 'flex' },
                width: '100%',
                mt: 3,
                p: 3,
                maxHeight: 380,
                minHeight: 345,
                overflowY: 'scroll'
              }}
            >
              <CollapsibleTable
                deviceTrip={deviceTripList?.data}
                loader={tripLoader}
                pageNumber={tripPageNumber}
                limit={tripDataPerPage}
                handlePageChange={handleTripPage}
                handleDataPerPage={handleTripDataPerPage}
                totalCount={deviceTripList?.total}
              />
            </Card>
          </Grid>
          <Grid item xs={12} md={5}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
              <Box
                data-testid="filter-date-container-small-screen"
                sx={{
                  display: { xs: 'flex', md: 'none' },
                  // flexWrap: 'wrap',
                  flexDirection: { xs: 'column', sm: 'row' },
                  justifyContent: 'end',
                  alignItems: 'center',
                  gap: '15px',
                  marginTop: '20px'
                }}
              >
                <Typography
                  sx={{
                    fontSize: '14px',
                    fontWeight: 'bold',
                    textAlign: 'start'
                  }}
                >
                  Filter By Date
                </Typography>

                <Box sx={{ display: 'flex', gap: '10px' }}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      slotProps={{
                        textField: {
                          inputProps: { 'data-testid': 'start-date-input-small' },
                          sx: {
                            '& .MuiInputBase-input': {
                              fontSize: '12px',
                              fontWeight: '600',
                              width: '70px',
                              padding: '10px'
                            }
                          }
                        }
                      }}
                      label="Start Date"
                      value={startDate}
                      onChange={handleStartDateChange}
                      format="DD/MM/YYYY"
                    />
                    <DatePicker
                      slotProps={{
                        textField: {
                          inputProps: { 'data-testid': 'end-date-input-small' },
                          sx: {
                            '& .MuiInputBase-input': {
                              fontSize: '12px',
                              fontWeight: '600',
                              width: '70px',
                              padding: '10px'
                            }
                          }
                        }
                      }}
                      label="End Date"
                      value={endDate}
                      onChange={handleEndDateChange}
                      format="DD/MM/YYYY"
                    />
                  </LocalizationProvider>
                  {feature?.device?.exportDeviceData && (
                    <Box data-testid="export-icon-small" onClick={() => setIsOpenExportModal(true)}>
                      {ExportIcon ? (
                        <ExportIcon
                          style={{ marginLeft: '10px', cursor: 'pointer' }}
                          // onClick={() => setIsOpenExportModal(true)}
                        />
                      ) : null}
                    </Box>
                  )}
                </Box>
              </Box>
              <Card sx={{ height: '100%' }}>
                <Box sx={{ width: '100%', typography: 'body1', height: '100%' }}>
                  <TabContext data-testid="device-alert-location-history-tabs" value={selectedTab}>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                      <TabList
                        variant="fullWidth"
                        onChange={handleTabChange}
                        aria-label="lab API tabs example"
                      >
                        <Tab label="Location" value="location" />
                        <Tab label="Alerts" value="alert" />
                        <Tab label="History" value="history" />
                      </TabList>
                    </Box>

                    <TabPanel
                      value="location"
                      sx={{ maxHeight: 490, minHeight: 490, overflowY: 'scroll' }}
                    >
                      {deviceEventData?.events?.length === 0 ? (
                        <NoDataAvailable />
                      ) : (
                        <Box>
                          <Timeline
                            sx={{
                              [`& .${timelineItemClasses.root}:before`]: {
                                flex: 0,
                                padding: 0
                              }
                            }}
                          >
                            {deviceEventData?.events?.map((item, index, arr) => (
                              <TimelineItem key={item.id}>
                                {eventLoader ? (
                                  <Skeleton
                                    sx={{ width: '100%', height: '50px' }}
                                    variant="rectangular"
                                  />
                                ) : (
                                  <>
                                    <TimelineSeparator>
                                      {/* <TimelineConnector /> */}
                                      <TimelineDot>
                                        {(() => {
                                          if (
                                            index === 0 ||
                                            index + 1 === deviceEventData?.events?.length
                                          ) {
                                            return (
                                              <LocationOnOutlinedIcon
                                                sx={{ color: 'black', fontSize: 15 }}
                                              />
                                            );
                                          }
                                          return (
                                            <FiberManualRecordIcon
                                              sx={{ color: 'black', fontSize: 12 }}
                                            />
                                          );
                                        })()}
                                      </TimelineDot>
                                      {index !== (arr?.length ?? 0) - 1 && (
                                        <TimelineConnector
                                          sx={{
                                            border: 'none',
                                            borderLeft: '2px dotted black',
                                            height: '100%',
                                            borderSpacing: '10px',
                                            backgroundColor: '#ffffff'
                                          }}
                                        />
                                      )}
                                    </TimelineSeparator>
                                    <TimelineContent sx={{ py: '12px', px: 2 }}>
                                      <Typography className={classes.locationHistoryTitle}>
                                        {item?.location ? item.location : 'Unknown Location'}
                                      </Typography>

                                      <Typography className={classes.locationHistoryAddress}>
                                        {moment(parseInt(item?.timestamp, 10)).format(
                                          'h:mm A, D MMM YYYY'
                                        )}
                                      </Typography>
                                    </TimelineContent>
                                  </>
                                )}
                              </TimelineItem>
                            ))}
                          </Timeline>
                          {deviceEventData?.pagination?.totalCount > 0 && (
                            <Pagination
                              pageNumber={pageNumber}
                              limit={dataPerPage}
                              handleChangePage={handlePageNumber}
                              handleChangeRowsPerPage={handleDataPerPage}
                              pageCount={deviceEventData?.pagination?.totalCount}
                            />
                          )}
                        </Box>
                      )}
                    </TabPanel>

                    <TabPanel
                      value="alert"
                      sx={{ maxHeight: 490, minHeight: 490, overflowY: 'scroll' }}
                    >
                      {deviceEventData?.events?.length === 0 ? (
                        <NoDataAvailable />
                      ) : (
                        <Box className={classes.boxStyle}>
                          {deviceEventData?.events?.map((item) =>
                            eventLoader ? (
                              <Skeleton
                                sx={{ width: '100%', marginBottom: '10px' }}
                                key={item?.id}
                                variant="rectangular"
                              />
                            ) : (
                              <div
                                key={item?.id}
                                style={{
                                  display: 'flex',
                                  justifyContent: 'space-between',
                                  alignItems: 'center',
                                  gap: '30px'
                                }}
                              >
                                <Box
                                  sx={{
                                    display: 'flex',
                                    gap: '5px',
                                    alignItems: 'center',
                                    width: '75%',
                                    cursor: item?.event_type === 'LOCK_OPENED' ? 'pointer' : 'text'
                                  }}
                                  onClick={() => handleUnlockChannelModal(item?.event_type, item)}
                                >
                                  <Typography
                                    className={classes.label}
                                    sx={{
                                      color: '#6F6F6F'
                                    }}
                                  >
                                    {getNotificationEventStatus(item?.event_type)}
                                  </Typography>
                                  {validEventTypes.includes(item?.event_type) &&
                                    getLlockOpenedByChannelIcon(item?.channel)}
                                </Box>
                                <Typography
                                  className={classes.label}
                                  style={{ color: '#171D40', width: '25%' }}
                                >
                                  {moment(parseInt(item?.timestamp, 10)).format(
                                    'hh:mm A, DD/MM/YYYY'
                                  )}
                                </Typography>
                              </div>
                            )
                          )}
                          {deviceEventData?.pagination?.totalCount > 0 && (
                            <Pagination
                              pageNumber={pageNumber}
                              limit={dataPerPage}
                              handleChangePage={handlePageNumber}
                              handleChangeRowsPerPage={handleDataPerPage}
                              pageCount={deviceEventData?.pagination?.totalCount}
                            />
                          )}
                        </Box>
                      )}
                    </TabPanel>
                    <TabPanel
                      value="history"
                      sx={{ maxHeight: 490, minHeight: 490, overflowY: 'scroll' }}
                    >
                      <Box className={classes.boxStyle}>
                        {deviceEventData?.events?.length === 0 ? (
                          <NoDataAvailable />
                        ) : (
                          deviceEventData?.events?.map((item) =>
                            eventLoader ? (
                              <Skeleton
                                key={item?.id}
                                sx={{ width: '100%', marginBottom: '10px' }}
                                variant="rectangular"
                              />
                            ) : (
                              <div
                                key={item.id}
                                style={{
                                  display: 'flex',
                                  justifyContent: 'space-between',
                                  alignItems: 'center',
                                  gap: '30px'
                                }}
                              >
                                <div
                                  style={{
                                    display: 'flex',
                                    gap: '5px',
                                    alignItems: 'center',
                                    width: '75%'
                                  }}
                                >
                                  <Typography
                                    className={classes.label}
                                    style={{ color: '#6F6F6F' }}
                                  >
                                    {getNotificationEventStatus(item?.event_type)}
                                  </Typography>
                                  {item?.event_type === 'LOCK_OPENED' &&
                                    getLlockOpenedByChannelIcon(item?.channel)}
                                </div>

                                <Typography
                                  className={classes.label}
                                  style={{ color: '#171D40', width: '25%' }}
                                >
                                  {moment(parseInt(item?.timestamp, 10)).format(
                                    'hh:mm A, DD/MM/YYYY'
                                  )}
                                </Typography>
                              </div>
                            )
                          )
                        )}
                        {deviceEventData?.pagination?.totalCount > 0 && (
                          <Pagination
                            pageNumber={pageNumber}
                            limit={dataPerPage}
                            handleChangePage={handlePageNumber}
                            handleChangeRowsPerPage={handleDataPerPage}
                            pageCount={deviceEventData?.pagination?.totalCount}
                          />
                        )}
                      </Box>
                    </TabPanel>
                  </TabContext>
                </Box>
              </Card>
            </Box>
          </Grid>
          <Grid item xs={12} sx={{ display: { xs: 'flex', md: 'none' } }}>
            <Card
              sx={{
                width: '100%',
                mt: 3,
                p: 3,
                maxHeight: 380,
                minHeight: 380,
                overflowY: 'scroll'
              }}
            >
              <Box>
                <CollapsibleTable
                  deviceTrip={deviceTripList?.data}
                  loader={tripLoader}
                  pageNumber={tripPageNumber}
                  limit={tripDataPerPage}
                  handlePageChange={handleTripPage}
                  handleDataPerPage={handleTripDataPerPage}
                  totalCount={deviceTripList?.total}
                />
              </Box>
            </Card>
          </Grid>
        </Grid>
      </Container>
      <DeviceReportExportModal
        handleClose={() => setIsOpenExportModal(false)}
        openAssignedModal={isOpenExportModal}
        deviceId={deviceDetail?.id}
      />

      {deviceSettingModal && (
        <DeviceSettingsModal
          openAssignedModal={deviceSettingModal}
          handleClose={() => setDeviceSettingModal(false)}
          deviceDetail={deviceDetail}
          setAlertMetas={setAlertMetas}
          alertMetas={alertMetas}
          onAction={(d) => getDeviceData(deviceId)}
        />
      )}
      {deviceMapModal && (
        <DeviceMapModal
          openAssignedModal={deviceMapModal}
          handleClose={() => setDeviceMapModal(false)}
          deviceDetail={deviceDetail}
          city={city}
        />
      )}
      {rfidDataModal && (
        <DeviceRfidModal
          openAssignedModal={rfidDataModal}
          handleClose={() => setRfidDataModal(false)}
          deviceId={deviceId}
          selectedRfidData={selectedRfidData}
        />
      )}
    </Page>
  );
}
